<template>
    <div>
        <p v-for="(paragraph, i) in paragraphs" :key="i" class="text-body-2 mb-2">{{ paragraph }}</p>
    </div>
</template>

<script>
export default {
    name: 'ReportParagraphs',

    props: {
        text: { type: String, default: '' },
    },

    computed: {
        // AI reports separate paragraphs with a blank line; plain HTML
        // collapses that whitespace, so split explicitly into <p> tags.
        paragraphs() {
            return this.text
                .split(/\n\s*\n/)
                .map(p => p.trim())
                .filter(Boolean);
        },
    },
};
</script>
